import styles from "./styles.module.scss";
import globalStyles from "../../../../assets/styles/base/globalPage.module.scss";

export const PlatformMetrics = ({ creditInfo = {} }) => {
  return (
    <section className={`${styles.metricsCover}`}>
      <div className={`${globalStyles.cardWithBackground} white`}>
        <p>Available Credit</p>
        <h5>{creditInfo?.available_balance || 0}</h5>
      </div>
      <div className={`${globalStyles.cardWithBackground} white`}>
        <p>Total Credit Used</p>
        <h5>{creditInfo?.used_amount}</h5>
      </div>
      {/* <div className={`${globalStyles.cardWithBackground} white`}>
        <p>TOTAL CREDIT LOADED</p>
        <h5>{creditInfo?.used_amount}</h5>
      </div> */}
      <div
        className={`${globalStyles.cardWithBackground} ${styles.metricsCover__card}`}
      >
        <p className="purple--text">Credit Conversion</p>
        <div className="d-flex justify-content-between">
          <p>{1} Credit</p>
          <h5>{1} Naira</h5>
        </div>
      </div>
    </section>
  );
};
